import React, { useState, useEffect } from 'react';
import { useSearchParams } from 'react-router-dom';
import { DashboardLayout } from '../../components/layout/DashboardLayout';
import CustomersTab from './CustomersTab';
import OrdersTab from './OrdersTab';

export default function Sales() {
    const [tab, setTab] = useState('orders');
    const [searchParams, setSearchParams] = useSearchParams();
    const [autoNew, setAutoNew] = useState(false);

    useEffect(() => {
        if (searchParams.get('new') === '1') {
            setTab('orders');
            setAutoNew(true);
            setSearchParams({}, { replace: true });
        }
        const t = searchParams.get('tab');
        if (t && ['orders', 'customers'].includes(t)) {
            setTab(t);
        }
    }, [searchParams, setSearchParams]);

    return (
        <DashboardLayout>
            <div className="space-y-4" data-testid="sales-page">
                <h1 className="page-title">Satis</h1>
                <div className="flex gap-1 border-b border-gray-100 pb-px">
                    {[
                        { k: 'orders', l: 'Siparisler' },
                        { k: 'customers', l: 'Musteriler' },
                    ].map(t => (
                        <button key={t.k} onClick={() => setTab(t.k)} className={`px-4 py-2.5 text-sm font-medium border-b-2 transition-colors ${tab === t.k ? 'border-gray-900 text-gray-900' : 'border-transparent text-gray-400 hover:text-gray-600'}`} data-testid={`tab-${t.k}`}>{t.l}</button>
                    ))}
                </div>
                {tab === 'orders' && <OrdersTab autoNew={autoNew} onAutoNewHandled={() => setAutoNew(false)} />}
                {tab === 'customers' && <CustomersTab />}
            </div>
        </DashboardLayout>
    );
}
